import { Injectable } from '@angular/core';
import { Headers, Http, URLSearchParams } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';
import { BaseResponse, StimeResponse, Stima } from "../core/core.component";
import { SelectItem } from 'primeng/primeng';

@Injectable()
export class StimeService {

    constructor(private http: Http) { }

    getStime(srmToken: string, dsRichiesta?: string,
        codRichiesta?: string,
        refOrder?: string,
        priorita?: string,
        tsRichiestaInizio?: Date,
        tsRichiestaFine?: Date,
        accettata?: string,
        ticket?: string,
        daEffettuare?: boolean):
        Observable<StimeResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/stime";
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        const formattedDtinizio = this.formatDateToISO(tsRichiestaInizio);
        const formattedDtfine = this.formatDateToISO(tsRichiestaFine);
        let body = {
            dsRichiesta: this.checkString(dsRichiesta),
            codRichiesta: this.checkString(codRichiesta),
            tsRichiestaDa:  formattedDtinizio,
            tsRichiestaA:  formattedDtfine,
            refOrder:  this.checkString(refOrder),
            priorita:  this.checkString(priorita),
            accettata:  this.checkString(accettata),
            ticket: this.checkString(ticket),
            daEffettuare : daEffettuare ? daEffettuare : false
        };

        return this.http.post(url, JSON.stringify(body), { headers: headers }).map((responseData) => responseData.json());
    }

    insertStima(srmToken, stima: Stima, creaTicket: boolean): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/stime/insert";
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        const formattedDtinizio = this.formatDateToISO(stima.tsrichiesta);
        const formattedDtfine = this.formatDateToISO(stima.tsrisposta);
        let body = {
            refOrder: stima.reforder,
            dsRichiesta: stima.dsrichiesta,
            codRichiesta: stima.codrichiesta,
            priorita: stima.priorita,
            tsRichiesta: formattedDtinizio,
            tsRisposta: formattedDtfine,
            giornate: stima.giornate,
            accettata: stima.accettata,
            ticket: stima.ticket,
            creaTicket: creaTicket
        };

        return this.http.post(url, JSON.stringify(body), { headers: headers }).map((responseData) => responseData.json());
    }

    updateOffer(srmToken, stima: Stima): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + '/stime/update/' + stima.idstima;
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        const formattedDtinizio = this.formatDateToISO(stima.tsrichiesta);
        const formattedDtfine = this.formatDateToISO(stima.tsrisposta);
        let body = {
            refOrder: stima.reforder,
            dsRichiesta: stima.dsrichiesta,
            codRichiesta: stima.codrichiesta,
            priorita: stima.priorita,
            tsRichiesta: formattedDtinizio,
            tsRisposta: formattedDtfine,
            giornate: stima.giornate,
            accettata: stima.accettata,
            ticket: stima.ticket
        };

        return this.http.put(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    private formatDateToISO(date: Date): string {
        if (!date) return null;
        return date.toISOString();
    }

    private checkString(value: string | null | undefined): string {
        if (value !== null && value !== undefined && value.trim() !== '') {
            return value;
        }
        return null;
    }

    deleteStima(srmToken, id: number): Observable<BaseResponse> {
        let url = environment.REST_SERVICE_BASE_URL + '/stime/delete/' + id;
        const headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/service/stime.service.ts